import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=6ff4dad0&scoped=true&"
import script from "./SquareButton.vue?vue&type=script&lang=js&"
export * from "./SquareButton.vue?vue&type=script&lang=js&"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=6ff4dad0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4dad0",
  null
  
)

export default component.exports